module.exports = __webpack_public_path__ + "static/media/misson3.5b050d04.svg";